<div>
    <h2 mat-dialog-title>Alert thresholds</h2>
    <mat-dialog-content fusePerfectScrollbar [fusePerfectScrollbarOptions]="{ suppressScrollX: true }" *ngIf="!loading">

      <form [formGroup]="activeForm" *ngIf="device.type == 'THW-PIN'">
        <mat-slide-toggle formControlName="temp_enabled" (change)="toggleTemp()">
          Enable temperature alerts
        </mat-slide-toggle>
        <mat-form-field appearance="standard" class="w-100-p">
          <mat-label>Minimum temperature (°F)</mat-label>
          <input matInput type="number" formControlName="min_temp" (change)="validateRange($event)"/>
          <mat-error *ngIf="activeForm.get('min_temp').hasError('min')">Minimum temperature must be higher than 1°F</mat-error>
          <mat-error *ngIf="activeForm.get('min_temp').hasError('noncompliant')"></mat-error>
          <mat-error *ngIf="activeForm.get('min_temp').hasError('encroaching')"></mat-error>
        </mat-form-field>
        <mat-form-field appearance="standard" class="w-100-p">
          <mat-label>Maximum temperature (°F)</mat-label>
          <input matInput type="number" formControlName="max_temp" (change)="validateRange($event)"/>
          <mat-error *ngIf="activeForm.get('max_temp').hasError('max')">Maximum temperature must be lower than 122°F</mat-error>
          <mat-error *ngIf="activeForm.get('min_temp').hasError('noncompliant')">Minimum temperature cannot exceed maximum</mat-error>
          <mat-error *ngIf="activeForm.get('max_temp').hasError('encroaching')">The difference between minimum and maximum must be at least 18°F</mat-error>
        </mat-form-field>
        <div class="err-spacer"></div>
        <mat-slide-toggle formControlName="humidity_enabled" (change)="toggleHumidity()">
          Enable humidity alerts
        </mat-slide-toggle>
        <mat-form-field appearance="standard" class="w-100-p">
          <mat-label>Minimum humidity (%)</mat-label>
          <input matInput type="number" formControlName="min_humidity" (input)="validateRange($event)"/>
          <mat-error *ngIf="activeForm.get('min_humidity').hasError('min')">Minimum humidity must be higher than 1%</mat-error>
          <mat-error *ngIf="activeForm.get('min_humidity').hasError('noncompliant')"></mat-error>
          <mat-error *ngIf="activeForm.get('min_humidity').hasError('encroaching')"></mat-error>
        </mat-form-field>
        <mat-form-field appearance="standard" class="w-100-p">
          <mat-label>Maximum humidity (%)</mat-label>
          <input matInput type="number" formControlName="max_humidity" (input)="validateRange($event)"/>
          <mat-error *ngIf="activeForm.get('max_humidity').hasError('max')">Maximum humidity must be lower than 99%</mat-error>
          <mat-error *ngIf="activeForm.get('max_humidity').hasError('noncompliant')">Minimum humidity cannot exceed maximum</mat-error>
          <mat-error *ngIf="activeForm.get('max_humidity').hasError('encroaching')">The difference between minimum and maximum must be at least 10%</mat-error>
        </mat-form-field>
      </form>

      <form [formGroup]="activeForm" *ngIf="device.type == 'Battery'">
        <mat-slide-toggle formControlName="batEnabled" (change)="toggleBat()">
          Notify if voltage falls below threshold
        </mat-slide-toggle>
        <mat-form-field appearance="standard">
          <mat-label>Minimum voltage (v)</mat-label>
          <input matInput type="number" formControlName="alert_threshold" step="0.1" required/>
          <mat-hint>Supported range: 10.0 - 12.7v</mat-hint>
          <mat-error *ngIf="activeForm.get('alert_threshold').hasError('required')">Threshold required</mat-error>
          <mat-error *ngIf="activeForm.get('alert_threshold').hasError('max')">Threshold cannot exceed 12.7v</mat-error>
          <mat-error *ngIf="activeForm.get('alert_threshold').hasError('min')">Threshold must be greater than 10.0v </mat-error>
        </mat-form-field>
      </form>

    </mat-dialog-content>
    <mat-dialog-actions align="end" class="mt-12">
      <button mat-button mat-dialog-close>Close</button>
      <button mat-button (click)="save()" [disabled]="!activeForm?.valid || !activeForm?.dirty">Save</button>
    </mat-dialog-actions>
  </div>
  